import styled from 'styled-components';
import realtimeFonts from '../../fonts';

export const counter = styled.span`
    ${realtimeFonts.value};
`;

